import { render, staticRenderFns } from "./ContactPanels.vue?vue&type=template&id=260e3c42&"
import script from "./ContactPanels.vue?vue&type=script&lang=js&"
export * from "./ContactPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports